"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVCx = void 0;
const _1 = require(".");
const typeName = 'SVCx';
class SVCx extends _1.Irrigator {
    constructor(ob) {
        super({ ...ob, type: typeName });
        this.type = typeName;
    }
}
exports.SVCx = SVCx;
